module.exports = __webpack_public_path__ + "img/thank-you.f714b3e1.webp";